import { RuntimeModel, http } from '@kunlun/dependencies';
import { stringifyToGraphql, graphqlQueryFormatter } from '../utils/serialize';

/**
 *
 * 查询限制省份code
 * @export
 * @param {RuntimeModel} rModel
 * @param {{
 *     buyerPartnerId?: any;
 *     sellerPartnerId?: any;
 *     ariesIssuingMethodEnum?: string;
 *   }} params
 * @return {*}
 */
export async function queryLimitProvinceList(
  rModel: RuntimeModel,
  params: {
    buyerPartnerId?: any;
    sellerPartnerId?: any;
    ariesIssuingMethodEnum?: string;
      querySource?: string;
  }
) {
  const gql = `
   query {
     sellerDistributionCreateOrderParamQuery {
       queryBuyerIssuingRules(data: ${stringifyToGraphql(params, ['ariesIssuingMethodEnum'])}) {
         code
       }
     }
   }
 `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.sellerDistributionCreateOrderParamQuery.queryBuyerIssuingRules;
}


/**
 *
 * 查询所有地址
 * @export
 * @param {RuntimeModel} rModel
 * @param {{
 *     buyerPartnerId?: any;
 *     sellerPartnerId?: any;
 *     ariesIssuingMethodEnum?: string;
 *   }} params
 * @return {*}
 */
export async function queryAddressDetailList(
    rModel: RuntimeModel,
    relationId: any
) {
    const gql = `
   query {
     ariesCoreCreateOrderDeliveryAddressQuery {
         queryPage(
               page: {currentPage: 1, size: 9999}
                     queryWrapper: {rsql: \"(1==1) and (relationId=='${relationId}')\", queryData: \"{}\"}
               ) {
                   content {
                     labelTitle
                     id      
                     }    
                   totalPages     
                   totalElements  
         }
     }
   }
 `;
    const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

    return res.data.ariesCoreCreateOrderDeliveryAddressQuery.queryPage.content;
}
